import { ConstantService } from './../constantService/constant.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {
  scope:any;
  apiUrl=ConstantService.API_ENDPOINT;

  headers: any;
  userId:any;
  accessToken:any;
    httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    
    
    constructor(
      private http:HttpClient
    ) {  this.headers = new Headers();
  
      this.headers.append("Access-Control-Allow-Origin", "*");
      this.headers.append(
        "Access-Control-Allow-Methods",
        "POST, GET, OPTIONS, PUT"
      );
      this.headers.append("Accept", "application/json");
      this.headers.append("content-type", "application/json");
      this.getLoginUserData();
    }
    getLoginUserData() {
      let loginUserData = JSON.parse(localStorage.getItem("loginUser"));
      if (loginUserData) {
        this.accessToken = loginUserData["id"];
        this.userId = loginUserData["userId"];
      }
    }
   addVoucher(data)
   {
    let filterJSON = {};
  
    let filter = encodeURI(JSON.stringify(filterJSON));
  
      let url=this.apiUrl+'vouchers/'+ "?access_token=" +
      this.accessToken +
      "&filter=" +
      filter;
      return new Promise ((resolve,reject)=>
      {
        this.http.post(url,data,this.httpOptions).subscribe((res)=>
        {
          console.log("New vouchers Is Added");
          resolve(res)
        },
        (err)=>
        {
          console.log(" Try Again");
          reject(err);
        })
      })
    }
   getVoucher()
   {
    let filterJSON = {};
  
    let filter = encodeURI(JSON.stringify(filterJSON));
    let url=this.apiUrl+'vouchers' +"?access_token=" +
    this.accessToken +
    "&filter=" +
    filter;
     return new Promise((resolve,reject)=>
     {
     this.http.get(url,this.httpOptions).subscribe((res)=>
     {console.log("vouchers are Fetched");
      resolve(res);
     },
     (err)=>
     {console.log(" Try Again");
       reject(err);
     }
     
     )} )
    }
    
    getVoucherDetail(id)
    {
     let filterJSON = {};
   
     let filter = encodeURI(JSON.stringify(filterJSON));
     let url=this.apiUrl+'vouchers/' +id+"?access_token=" +
     this.accessToken +
     "&filter=" +
     filter;
      return new Promise((resolve,reject)=>
      {
      this.http.get(url,this.httpOptions).subscribe((res)=>
      {console.log("Voucher Is Fetched");
       resolve(res);
      },
      (err)=>
      {console.log(" Try Again");
        reject(err);
      }
      
      )} )
     }

     EditVoucherDetail(id,data)
     {
      let filterJSON = {};
    
      let filter = encodeURI(JSON.stringify(filterJSON));
      let url=this.apiUrl+'vouchers/' +id+"?access_token=" +
      this.accessToken +
      "&filter=" +
      filter;
       return new Promise((resolve,reject)=>
       {
       this.http.patch(url,data,this.httpOptions).subscribe((res)=>
       {console.log("Voucher Is Edited");
        resolve(res);
       },
       (err)=>
       {console.log(" Try Again");
         reject(err);
       }
       
       )} )
      }
  
   deleteVoucherDetail(id)
  { let filterJSON = {};
  
  let filter = encodeURI(JSON.stringify(filterJSON));
  
   let url=this.apiUrl+'vouchers/'+id +"?access_token=" +
   this.accessToken +
   "&filter=" +
   filter;
   return new Promise((resolve,reject)=>
   {
   this.http.delete(url,this.httpOptions).subscribe((res)=>
   {console.log("Voucher Is Deleted");
    resolve(res);
   },
   (err)=>
   {console.log(" Try Again");
     reject(err);
   }
   
   )} )
  }
  
   }

